import { Http } from '../axios/interceptors'

export const getCompany = async guid => Http('GET', `/Companies/Get?guid=${guid}`)

export const allCompanies = async (param) => Http('GET', '/Companies/GetList?', param)

export const getDolar = async guid => Http('GET', `/Companies/GetDolar?guid=${guid}`)

export const createOrEditCompany = async (body, id = null) => (id ? Http('PUT', `/Companies/Update`, null, body) : Http('POST', '/Companies/Create', null, body))

export const createOrEditSucursal = async (body, id = null) => (id ? Http('PUT', `/Companies/CreateSucursal`, null, body) : Http('POST', '/Companies/CreateSucursal', null, body))

export const createCompanyFast = async (body) => ( Http('POST', '/Companies/CreateFast', null, body))

export const getPaymentMethodsCompany = async guid => Http('GET', `/Companies/GetListPaymentMethods?guidCompany=${guid}`)

export const inactiveByPayment = async guid => Http('GET', `/Companies/InactiveByPayment?guid=${guid}`)

export const deleteCompany = async guid => Http('PUT', `/Companies/Inactive?guid=${guid}`)

export const updateRate = async body => Http('PUT', `/Companies/UpdateTasaDolar`, null, body)

export const getListSucursales = async (param)=> Http('GET', `/Companies/GetListSucursales`,param)


// ---------------------------------- users

export const showUser = async id => Http('GET', `/users/${id}`)

export const postOrPutUser = async (body, id = null) => (id ? Http('PUT', `/users/${id}`, null, body) : Http('POST', '/users', null, body))

export const allRoles = async () => Http('GET', '/roles')

export const allRolesDist = async () => Http('GET', '/roles-admin')

export const allUsersAdmin = async () => Http('GET', '/user-admin')

export const deletePaymentMethods = async (guid, id) => Http('DELETE', `/Companies/DeletePaymentMethods?guidCompany=${guid}&idCompanyPaymentMethods=${id}`)

export const deleteHoursMethods = async (guid, id) => Http('DELETE', `/Companies/DeleteWorkSchedules?guidCompany=${guid}&idCompanyWorkingHours=${id}`)

export const deleteDeliveryCosts = async (guid, id) => Http('DELETE', `/Companies/DeleteDeliveryCosts?guidCompany=${guid}&idCostDelivery=${id}`)
